<template>
  <div>
    <loading :active.sync="isLoading" background-color="#D0D0D0	">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5">
          <div></div>
        </div>
      </div>
    </loading>
    <div id="SliderTop">
      <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
    </div>

    <div class="MbDevice" v-if="show">
      <div v-if="showChatRoom">
        <div class="floatChatIcon " @click.prevent="updatavisible">
          <i class="far fa-comment-dots fa-2x text-white"></i>

          <div class="unreadFrame">
            <span class="mesbadge badge badge-pill" v-if="UnreadNum !== 0">
              {{ UnreadNum }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-show="ShowRoom">
      <div id="myDIV" :class="{ 'disable-pull': mobile && Roomvisible }">
        <div class="Chatbox" :class="{ mobile, minimal: !Roomvisible }">
          <Chatroom />
        </div>
      </div>
    </div>

    <div class="data-box " v-if="ListStatus">
      <Userlist></Userlist>
    </div>
    <div v-if="show">
      <router-view> </router-view>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'
  import Userlist from '@/components/Userlist.vue'
  import isMobile from 'ismobilejs'
  import ConversationClient from 'conversation-client'

  import Chatroom from '@/components/Chatroom.vue'

  export default {
    name: 'Home',

    components: {
      Userlist,
      Chatroom,
      ConversationClient,
    },

    data() {
      return {
        show: true,
        proInterestList: [],
        optionInterPro: [], //給選擇興趣的產品欄位用
        s_optionInterPro: '',
        categoryAll: [],
        s_categoryAll: '',

        OnlineExpoStatus: '', //判斷狀態
        mobile: isMobile(window.navigator).any,
        showChatRoom: false,
        Nowdate: '',
        ExpoBegin: '',
        ExpoEnd: '',
        ExpoPreOpen: '',
      }
    },

    computed: {
      ...mapGetters(['isLoading', 'ListStatus', 'Roomvisible', 'ShowRoom', 'UnreadNum', 'exhcode']),
    },

    watch: {
      optionInterPro: function(newValue) {
        this.s_optionInterPro = newValue.toString()
      },
      categoryAll: function(newValue) {
        this.s_categoryAll = newValue.toString()
      },

      Roomvisible(v) {
        if (v && this.mobile) {
          document.getElementById('myDIV').classList.add('disable-pull')
        } else {
          document.getElementById('myDIV').classList.remove('disable-pull')
        }
      },

      UnreadNum(newValue) {
        if (this.UnreadNum !== newValue) {
          this.$store.dispatch('getUnread', newValue)
        }
      },
    },

    methods: {
      updatavisible() {
        if (this.Roomvisible) {
          if (this.ShowRoom) {
            this.$bus.$emit('callClose')
          } else {
            this.$store.dispatch('ShowChatRoom', true)
          }
        } else {
          this.$store.dispatch('ShowChatRoom', true)
          this.$store.dispatch('Updatevisible', true)
        }
      },

      alertSuccess(Status) {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
          allowEnterKey: true,
        }).then(function() {
          if (Status == 'Out') {
            vm.show = true
          } else if (Status == 'In') {
            window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Exhibitors/Page=1`)
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          allowEnterKey: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },
    },

    created() {
      //判斷開啟頁面有無使用觸碰功能以評估桌機行動裝置
      function isMobile() {
        try {
          document.createEvent('TouchEvent')
          return true
        } catch (e) {
          return false
        }
      }

      if (!isMobile()) {
        //桌機就啟動tooltip提示功能
        $('body').tooltip({ selector: '[data-toggle=tooltip]' })
      }

      const vm = this

      vm.showChatRoom = false
      vm.$store.dispatch('updateLoading', true)
      vm.show = false

      //置頂
      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function() {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop')
                .stop()
                .fadeOut(222)
            }
          })
          .scroll()
      })

      let NowPageUrl = location.href
      let Urlname = NowPageUrl.split('/')[5]

      if (Urlname == 'ExhibitorDetail') {
        sessionStorage.setItem('Exhurl', NowPageUrl)
      }

      //取得當前時間

      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitions/${vm.exhcode}?lang=en`)
        .then((response) => {
          //先取得時間段API

          vm.Nowdate = Date.parse(new Date()).valueOf()
          vm.ExpoBegin = response.data.OnlineExpoBegin
          vm.ExpoEnd = response.data.OnlineExpoEnd
          vm.ExpoPreOpen = response.data.OnlineExpoMovein

          console.log(vm.ExpoEnd)

          if (Urlname !== 'Login' && Urlname !== 'Registration' && Urlname !== 'Signup' && Urlname !== 'Landing') {
            vm.showChatRoom = true

            const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
            vm.$http.post(api).then((response) => {
              if (response.data == 200) {
                sessionStorage.setItem('access', '200')

                const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                vm.$http.post(registerApi).then((response) => {
                  if (response.data == 200) {
                    // 判斷非參展商的時間段

                    if (vm.Nowdate < vm.ExpoBegin) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    } else {
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
                    }
                  } else if (response.data == 252) {
                    alert('Please complete the questionnaire to finish the visit registration')

                    window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Registration`)
                  } else if (response.data == 251) {
                    window.location.replace(`https://www.chanchao.com.tw/en/`)
                  } else if (response.data == 253) {
                    vm.show = true
                    vm.$store.dispatch('updateLoading', false)
                  } else if (response.data == 254) {
                    // 判斷參展商用戶時間段

                    if (vm.Nowdate < vm.ExpoPreOpen) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoPreOpen && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    } else {
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
                    }
                  }
                })
              } else {
                //251 的狀態
                sessionStorage.setItem('access', '')
                sessionStorage.removeItem('access')
                alert('You are not logged in.')

                window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
              }
            })
          } else if (Urlname == 'Login') {
            //時間段判斷(只需取出畢展日期即可，當到期時就導到landing頁)
            //下方就不用時間段判斷來判定，直接比較日期

            if (vm.Nowdate < vm.ExpoEnd) {
              const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
              vm.$http.post(api).then((response) => {
                if (response.data == 200) {
                  alert('You are already logged in.')
                  window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                } else {
                  vm.show = true
                  vm.$store.dispatch('updateLoading', false)
                }
              })
            } else {
              window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
            }
          } else if (Urlname == 'Registration') {
            //登錄功能外層設定是確定未畢展的情況下，都要能進去
            if (vm.Nowdate < vm.ExpoEnd) {
              const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
              vm.$http.post(api).then((response) => {
                if (response.data == 200) {
                  const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                  vm.$http.post(registerApi).then((response) => {
                    if (response.data == 200) {
                      alert('You are already registered .')
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                    } else if (response.data == 252) {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    } else if (response.data == 251) {
                      window.location.replace(`https://www.chanchao.com.tw/en/`)
                    } else if (response.data == 253) {
                      alert('You are already registered .')
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                    } else if (response.data == 254) {
                      alert('You are already registered .')
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                    }
                  })
                } else {
                  alert('You are not logged in. ')
                  window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
                }
              })
            } else {
              window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
            }
          } else if (Urlname == 'Signup') {
            if (vm.Nowdate < vm.ExpoEnd) {
              vm.show = false
              vm.$store.dispatch('updateLoading', true)
              const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
              vm.$http.post(api).then((response) => {
                if (response.data == 200) {
                  alert('You are already logged in.')
                  window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                } else {
                  vm.show = true
                  vm.$store.dispatch('updateLoading', false)
                }
              })
            } else {
              window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Landing`)
            }
          } else if (Urlname == 'Landing') {
            const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
            vm.$http.post(api).then((response) => {
              if (response.data == 200) {
                const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                vm.$http.post(registerApi).then((response) => {
                  if (response.data == 200) {
                    // 判斷非參展商的時間段

                    if (vm.Nowdate < vm.ExpoBegin) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                    } else {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    }
                  } else if (response.data == 252) {
                    vm.show = true
                    vm.$store.dispatch('updateLoading', false)
                  } else if (response.data == 251) {
                    window.location.replace(`https://www.chanchao.com.tw/en/`)
                  } else if (response.data == 253) {
                    console.log('Exhibition closed')
                    vm.show = true
                    vm.$store.dispatch('updateLoading', false)
                  } else if (response.data == 254) {
                    // 判斷參展商用戶時間段

                    if (vm.Nowdate < vm.ExpoPreOpen) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoPreOpen && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      window.location.replace(`https://www.chanchao.com.tw/TairosAutomation/onlineexpo/Home`)
                    } else {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    }
                  }
                })
              } else {
                vm.show = true
                vm.$store.dispatch('updateLoading', false)
              }
            })
          }
        })
    },
  }
</script>

<style lang="scss">
  .data-box {
    position: fixed;
    top: 88px;
    right: 79px;
    width: 270px;
    height: 400px;
    z-index: 2900;
  }
  .title_fontStyle {
    color: #575757;
  }

  a:hover {
    color: #707272;
    text-decoration: none;
  }

  a {
    color: #2d2e2e;
  }

  .pointer {
    cursor: pointer;
  }

  p {
    margin-top: 0;
    margin-bottom: 0rem;
  }

  ul {
    list-style: none;
  }

  .pagination-sm .page-link {
    padding: 7px;
    font-size: 1rem;
  }

  .pagination-lg .page-link {
    padding: 6px;
    font-size: 0.9rem;
  }

  .page-link {
    color: #000000;
    &:hover {
      color: #666666;
    }
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #af0d69;
    border-color: #c9c9c9;
  }

  .brightnessHover {
    &:hover {
      filter: brightness(1.2);
      cursor: pointer;
    }
  }

  .breadcrumb {
    background-color: #f8f8f8;
  }

  .ellipsis_breadcrumb {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .MbDevice {
    display: none;
  }

  .PcDevice {
    display: block;
  }

  @media (max-width: 960px) {
    .MbDevice {
      display: block;
    }

    .PcDevice {
      display: none;
    }
  }

  //Logo長度設定
  .WidthLongLogo {
    display: block;
  }

  .WidthShortLogo {
    display: none;
  }

  @media (max-width: 1700px) {
    .WidthLongLogo {
      display: none;
    }

    .WidthShortLogo {
      display: block;
    }
  }

  .BannerHover:hover {
    box-shadow: 2px 2px 15px 8px rgba(255, 255, 255, 0.322);
    opacity: 0.8;
    cursor: pointer;
  }

  //圖片卡片資訊

  .card-effect {
    border-radius: 0.35rem;

    &:hover {
      box-shadow: 1px 1px 8px 1px #d1cfcf;
      filter: brightness(1.1);
    }
  }

  @keyframes ldio-f9ujl5oazv5 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .ldio-f9ujl5oazv5 div {
    position: absolute;
    animation: ldio-f9ujl5oazv5 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    box-shadow: 0 4px 0 0 #777b7c;
    transform-origin: 80px 82px;
    z-index: 10002;
  }
  .loadingio-spinner-eclipse-y24d302hfm {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    z-index: 10002;
  }
  .ldio-f9ujl5oazv5 {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
    z-index: 10002;
  }
  .ldio-f9ujl5oazv5 div {
    box-sizing: content-box;
    z-index: 10002;
  }

  //scrollTop

  .toTop-arrow {
    position: fixed;
    bottom: 30px;
    right: 5px;
    width: 50px;
    height: 50px;
    background: #dfd5dd;
    border-style: solid;
    border-color: #d5d2bf;
    padding: 5px;
    padding-left: 8px;
    z-index: 3000;
    cursor: pointer;
    opacity: 0.7;
    border-radius: 30px;

    &:hover {
      background: #b1adb0;
    }
  }

  .floatChatIcon {
    position: fixed;
    top: 440px;
    right: 5px;
    width: 50px;
    height: 50px;
    background: #b40f6cda;
    border-radius: 30px;
    padding: 5px;
    z-index: 800;
    cursor: pointer;
    opacity: 0.7;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3000;
  }

  .unreadFrame {
    position: relative;
  }

  .mesbadge {
    position: absolute;
    top: 12px;
    right: 28px;
    font-size: 13px;
    background-color: #e0492e;
    color: #fff;
  }

  #myDIV {
    z-index: 4002;
  }

  .Chatbox {
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 900px;
    height: 590px;
    z-index: 4000;
  }

  .disable-pull {
    position: fixed;
    top: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }

  .mobile {
    right: 0;
    width: 100%;
    height: 100%;
  }

  .minimal {
    width: 0;
    height: 0;
  }

  .iconOpenHover {
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }

  .swal2-container {
    z-index: 10001;
  }

  //淡出動畫效果
  @keyframes flicker {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 1.2;
    }
  }
  .flicker {
    animation: flicker 1.5s linear;
    animation-iteration-count: 2;
  }

  @keyframes flicker_card {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 2;
    }
  }

  .flicker_card {
    animation: flicker_card 1s infinite;
  }
</style>
